export default __webpack_public_path__ + "static/media/sprint-start.86adf705.gif";